/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Employee } from '../models/Employee';
import type { ListResponse } from '../models/ListResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class EmployeeService {

    /**
     * Get a list of `Employee`s
     * @returns any A list of `Employee`s.
     * @throws ApiError
     */
    public static listEmployees({
page,
size,
filter,
sort,
searchTerm,
}: {
/**
 * Page number
 */
page?: number,
/**
 * Number of items per page
 */
size?: number,
/**
 * A filter to apply to the results. Multiple filters can be applied by using the same parameter name multiple times. String must be URL encoded. String follows the format field,operator,value(s),required. Filters can be applied to associations by using `[associatedModel*].[attribute]` as field. If values is an array, which is allowed for e.g. the operators "in", "notIn" etc, the delimiter "|" must be used. "required" is allowed, if a deep filter (= filter on an association) is set. In this case, only entities that have an associated entity are returned. *model name should be written as in the API Response, meaning with lowercase first letter and if need be in plural. `required` is optional
 */
filter?: string,
/**
 * Sorts the results by the given field and order. The format is field:order. The order can be asc or desc. Multiple fields can be sorted by using a comma separated list.
 */
sort?: string,
/**
 * Seach Term for full text search. Whether supported and which fields are included depends on the model.
 */
searchTerm?: string,
}): CancelablePromise<ListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employees',
            query: {
                'page': page,
                'size': size,
                'filter': filter,
                'sort': sort,
                'searchTerm': searchTerm,
            },
        });
    }

    /**
     * Get the logged-in employee's details
     * @returns Employee The details of the logged-in employee
     * @throws ApiError
     */
    public static getSelf(): CancelablePromise<Employee> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employees/me',
        });
    }

    /**
     * Get an `Employee` by ID
     * @returns Employee A single `Employee`.
     * @throws ApiError
     */
    public static getEmployee({
id,
}: {
/**
 * ID
 */
id: string,
}): CancelablePromise<Employee> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/employees/{id}',
            path: {
                'id': id,
            },
        });
    }

    /**
     * Update a specific `Employee`
     * @returns Employee A single `Employee`.
     * @throws ApiError
     */
    public static updateEmployee({
id,
requestBody,
}: {
/**
 * ID of the `Employee`
 */
id: string,
requestBody: Employee,
}): CancelablePromise<Employee> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/employees/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
